export default "__VITE_ASSET__agwWMI$y__"